/** FollowUpEngineRoute — skin-aware switcher for /follow-up-engine. */
import { useUISkin } from "@/data/UISkinContext";
import FollowUpEngine from "./FollowUpEngine";
import FollowUpEngineCockpit from "./FollowUpEngineCockpit";

export default function FollowUpEngineRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <FollowUpEngineCockpit />;
  return <FollowUpEngine />;
}
